module.exports = __webpack_public_path__ + "static/media/act-overview.d6f8daa7.svg";